module.exports = __webpack_public_path__ + "assets/menu-empty-search-571ff4.svg";